import { render } from "./CharacteristicHistory.vue?vue&type=template&id=0f38a6b3"
import script from "./CharacteristicHistory.vue?vue&type=script&lang=js"
export * from "./CharacteristicHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__